import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { FleetVehicle } from '../../views/shared/policies/auto/create-policy';

export interface QuoteWidgetPayload {
  insurerPortfolioId: number | null;
  excessBought: boolean;
  riskTypeId: number | null;
  extraTppdlLimit: number;
  umbrellaLimit: number;
  startDate: string | null;
  endDate: string | null;
  currency: string;
  currencyRate: number;
  registrationYear: number | null;
  sumInsured: number | null;
  noOfSeats: number;
  leadSource: string | null;
  insurerId: number | string;
  applyNcd: boolean;
  ncdRate: number | null;
}

interface IInitialState {
  PAYLOAD: QuoteWidgetPayload | null;
  QUOTE_RESPONSE: any | null;
  IS_QUOTE_CALCULATOR: boolean;
  IS_FLEET_QUOTE_CALCULATOR: boolean;
  selectedInstallmentData: any | null;
  selectedInstallment: string | null;
  vehicles: FleetVehicle[];
}

const initialState: IInitialState = {
  PAYLOAD: null,
  QUOTE_RESPONSE: null,
  IS_QUOTE_CALCULATOR: false,
  selectedInstallmentData: null,
  selectedInstallment: null,
  IS_FLEET_QUOTE_CALCULATOR: false,
  vehicles: []
};

const quoteWidgetSlice = createSlice({
  name: 'quoteWidget',
  initialState,
  reducers: {
    SET_QUOTE_WIDGET_PAYLOAD: (state, action: PayloadAction<QuoteWidgetPayload | null>) => {
      state.PAYLOAD = action.payload;
      state.IS_QUOTE_CALCULATOR = true;
    },
    SET_QUOTE_WIDGET_RESPONSE: (state, action: PayloadAction<any | null>) => {
      state.QUOTE_RESPONSE = action.payload;
    },
    SET_SELECTED_INSTALLMENT_DATA: (state, action: PayloadAction<any | null>) => {
      state.selectedInstallmentData = action.payload;
    },
    SET_SELECTED_INSTALLMENT: (state, action: PayloadAction<any | null>) => {
      state.selectedInstallment = action.payload;
    },
    SET_FLEET_VEHICLES: (state, action: PayloadAction<any | null>) => {
      state.vehicles = action.payload;
    },
    SET_IS_FLEET_QUOTE_CALCULATOR: (state, action: PayloadAction<any | null>) => {
      state.IS_FLEET_QUOTE_CALCULATOR = action.payload;
    },
    CLEAR_QUOTE_WIDGET_PAYLOAD: (state) => {
      state.PAYLOAD = null;
      state.QUOTE_RESPONSE = null;
      state.IS_QUOTE_CALCULATOR = false;
      state.IS_FLEET_QUOTE_CALCULATOR= false,
      state.selectedInstallmentData = null;
      state.selectedInstallment = null;
    }
  }
});

export const getQuoteWidgetPayloadFromState = (state: RootState): IInitialState | null => {
  return {
    PAYLOAD: state.quoteWidget.PAYLOAD,
    QUOTE_RESPONSE: state.quoteWidget.QUOTE_RESPONSE,
    IS_QUOTE_CALCULATOR: state.quoteWidget.IS_QUOTE_CALCULATOR,
    IS_FLEET_QUOTE_CALCULATOR: state.quoteWidget.IS_FLEET_QUOTE_CALCULATOR,
    selectedInstallmentData: state.quoteWidget.selectedInstallmentData,
    selectedInstallment: state.quoteWidget.selectedInstallment,
    vehicles: state.quoteWidget.vehicles,
  }
};

export const { SET_QUOTE_WIDGET_PAYLOAD, SET_QUOTE_WIDGET_RESPONSE, SET_FLEET_VEHICLES, SET_SELECTED_INSTALLMENT_DATA, SET_SELECTED_INSTALLMENT, SET_IS_FLEET_QUOTE_CALCULATOR, CLEAR_QUOTE_WIDGET_PAYLOAD } = quoteWidgetSlice.actions;
export default quoteWidgetSlice.reducer;
